import { useContext } from 'react';
import { ThemeContext } from 'styled-components';

var useTheme = function () { return useContext(ThemeContext); };

export { useTheme as u };
//# sourceMappingURL=useTheme-923b5048.js.map
